import { render, staticRenderFns } from "./sport_news_feed.vue?vue&type=template&id=0e41fc4e&scoped=true&"
import script from "./sport_news_feed.vue?vue&type=script&lang=js&"
export * from "./sport_news_feed.vue?vue&type=script&lang=js&"
import style0 from "./sport_news_feed.vue?vue&type=style&index=0&id=0e41fc4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e41fc4e",
  null
  
)

export default component.exports